module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/brand-design-colony-square.json
// module id = 405
// module chunks = 43040732576999